import type { AmbientMedication } from './ambient-types';

/**
 * The dictated words as one sentence, for `sig`.
 *
 * Assembled from every populated field rather than taken from `instructions` alone: the model
 * spreads the sig across five fields and any one of them can be the only one populated, so reading
 * only `instructions` would drop the dose on the reported case (which carried `dose` + `frequency`
 * and no `instructions` at all).
 */
export function dictatedSig(med: AmbientMedication): string {
  return [med.dose, med.route, med.frequency, med.duration, med.instructions]
    .map((part) => part?.trim())
    .filter((part): part is string => !!part)
    .join(' ');
}
